/* eslint-disable ordered-imports/ordered-imports */
/* eslint-disable spire/export-styles */
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Menu from "@insite/mobius/Menu";
import Popover from "@NA/Components/ADIHeaderPopover";
import HeaderMenuLinkManager from "@NA/Components/HeaderMenuLinkManager";
import * as React from "react";
import { ThemeProps, withTheme } from "styled-components";
import { MainNavigationStyles, MappedLink } from "@NA/Overrides/Widgets/Header/MainNavigation";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { connect } from "react-redux";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Hidden from "@insite/mobius/Hidden";

interface OwnProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement>;
    isOpen: boolean;
    isAuth: boolean;
    toggleLogin: Function;
    displayChangeCustomerLink: boolean;
    zoneId: string;
}
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        popover: state.ADIGlobalData.ClosePopOverStore.closeMenuPopover,
    };
};

type Props = ThemeProps<BaseTheme> & OwnProps & ReturnType<typeof mapStateToProps>;

class MainNavigationItem extends React.Component<Props> {    
    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();
    state = {
        activeTab: "",
    };
    componentDidUpdate(prevProps: Readonly<Props>) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.openPopover();
        } else if (!this.props.isOpen && prevProps.isOpen) {
            this.closePopover();
        }

        if (this.props.popover !== prevProps.popover) {
            this.closePopover();
        }
    }

    closePopover = () => {
        const menuLink = document.querySelector(".menu-item.activeTab");
        if (menuLink) {
            menuLink.classList.remove("activeTab");
        }
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        //ADI-1633
        var getSelectBox = document.getElementById("coveoPagerSortTypeSelector");
        if (getSelectBox) {
            getSelectBox.blur();
        }

        this.popover.current && (this.popover.current! as any).openPopover();
    };

    handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement | HTMLUListElement, MouseEvent>) => {
        this.openPopover();
        this.setState({ activeTab: e.currentTarget.id.split("_")[1] });

        const searchinputPopover = document.getElementById("headerSearch-popover");
        const searchinputPopoverOverlay = document.getElementById("overlay-div");

        if (searchinputPopover && searchinputPopoverOverlay) {
            searchinputPopover.style.display = "none";
            searchinputPopoverOverlay.style.display = "none";
        }
    };

    handleMouseLeave = (e: React.MouseEvent<HTMLAnchorElement | HTMLUListElement, MouseEvent>) => {
        this.setState({ activeTab: "" });
    };

    handleKeyDown = (e: any) => {
        // alert("clicked");
        if(e.key === 'Enter' || e.keyCode === 13){
            this.openPopover();
            this.setState({ activeTab: e.currentTarget.id.split("_")[1] });
            const searchinputPopover = document.getElementById("headerSearch-popover");
            const searchinputPopoverOverlay = document.getElementById("overlay-div");
 
            if (searchinputPopover && searchinputPopoverOverlay) {
                searchinputPopover.style.display = "none";
                searchinputPopoverOverlay.style.display = "none";
            }
        }
        
    };
    
    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            isAuth,
            toggleLogin,
            zoneId,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading = hasChildren && link.childrenType === "CascadingMenu";
        const isMega = hasChildren && link.childrenType === "MegaMenu";
        const isActive = link.title === this.state.activeTab;        
        const generateUrl = () => {
            if (!isAuth && link.isLoggedInRequired) {
                toggleLogin({ loginDrawer: true });
            } else {
                window.location.href = link.url;
            }
        };

        let menuLink = (
            <>
                {link.title !== "Service" && (
                    <Link
                        className={`menu-item ${isActive ? "activeTab" : ""}`}
                        data-test-selector="megaMenuHover"
                        typographyProps={styles.menuItemTypography}
                        color={styles.menuItemTypography?.color}
                        {...styles.menuItem}
                        onClick={generateUrl}
                        target={link.openInNewWindow ? "_blank" : ""}
                        hoverStyle={{
                            textDecoration: isActive ? "underline #020508 4px" : "none",
                        }}
                    >
                        {link.title}
                        {isCascading && downIcon}
                    </Link>
                )}
            </>
        );
        if (isMega || link.url === "") {
            menuLink = (
                <Link
                    className={`menu-item ${isActive ? "activeTab" : ""}`}
                    data-test-selector="megaMenuHover"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                    hoverStyle={{
                        textDecoration: isActive ? "underline #020508 4px" : "none",
                    }}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                    onKeyDown={this.handleKeyDown}                    
                >
                    {link.title}
                    {(isCascading || isMega) && downIcon}
                    <Hidden below="lg">
                        <StyledWrapper className="menuLeftHover"></StyledWrapper>
                        <StyledWrapper className="menuRightHover"></StyledWrapper>
                    </Hidden>
                </Link>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${link.title}_${index}`}
                    menuItems={link.children}
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }

        if (isMega) {
            menuItem = (
                <Popover
                    data-test-selector="megaMenuHover"
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    contentBodyProps={{
                        ...styles.megaMenu?.contentBodyProps,
                        _width: 1140,
                        as: "div",
                    }}
                    controlsId={`${index}_${link.title}`}
                    ref={this.popover}
                    positionFunction={(element: React.RefObject<HTMLUListElement>) => {
                        if (this.props.container.current) {
                            const parentPosition = this.props.container.current.getBoundingClientRect();
                            const rect = element.current?.getBoundingClientRect();
                            const top = rect ? rect.top + (rect.height > 100 ? styles.menuHeight : rect.height) : 0;
                            const offsetTop = top;
                            const cartWidth = 150;
                            const breakpointMaxWidth = maxWidths.find((value: number, index: number) => {
                                return (
                                    parentPosition.width + cartWidth <= value &&
                                    parentPosition.width + cartWidth > maxWidths[index - 1]
                                );
                            });

                            const width = breakpointMaxWidth ? breakpointMaxWidth - 30 : parentPosition.width;

                            return {
                                top: `${offsetTop}px`,
                                position: "fixed",
                                left: "0rem",
                                width: `100%`,
                                maxWidth: "1470px",
                                maxHeight: "calc(100vh - 132px)",
                                overflow: "hidden auto",
                                minWidth: "calc(100% - 140px)",
                                height: `${link.megaMenuName === "Shop" ? "calc(100vh - 132px)" : "auto"}`,
                            };
                        }
                        return {
                            position: "absolute"
                        };
                    }
                    }
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                    // onMouseOver={e => this.handleMouseEnter(e)}
                    // onMouseLeave={this.handleMouseLeave}
                    onMouseEnter={this.handleMouseEnter} // Handle popover hover
                    onMouseLeave={this.handleMouseLeave} // Handle popover leave                    
                >
                    <GridContainer
                        className="mega-menu-grid-container"
                        data-test-selector={`mainNavigationItem_${index}`}
                        {...styles.megaMenuGridContainer}
                        offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                    >
                        <HeaderMenuLinkManager
                            zoneId={zoneId}
                            link={link}
                            styles={styles}
                            onHandleClose={this.closePopover}
                        />
                    </GridContainer>
                </Popover >
            );
        }

        return menuItem;
    }
}

export default connect(mapStateToProps)(withTheme(MainNavigationItem));
